import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { AsyncInfoService } from './asyncInfo.service';
import { AsyncInfoRequestViewModel, AsyncInfoResponseViewModel } from './asyncInfo.types';
import { AsyncInfoPopupComponent } from './popup/asyncInfoPopup.component';

@Component({
    selector: 'app-async-info',
    templateUrl: './asyncInfo.component.html',
})
export class AsyncInfoComponent extends ComponentBase implements OnInit {
    @ViewChild(AsyncInfoPopupComponent)
    private asyncPopup: AsyncInfoPopupComponent;

    displayModal: boolean = false;
    visible: boolean = false;

    asyncInfoRequestCollection: AsyncInfoRequestViewModel[];

    constructor(
        protected confirmationService: ConfirmationService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        protected asyncInfoService: AsyncInfoService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.asyncInfoRequestCollection = new Array<AsyncInfoRequestViewModel>();

        this.asyncInfoService.requestAsyncInfoEvent.subscribe((s: AsyncInfoRequestViewModel) => this.beginRequest(s));

        this.asyncInfoService.responseAsyncInfoEvent.subscribe((s: AsyncInfoResponseViewModel) => this.endRequest(s));
    }

    beginRequest(request: AsyncInfoRequestViewModel) {
        this.visible = true;

        this.asyncInfoRequestCollection.push(request);
    }
    endRequest(request: AsyncInfoResponseViewModel) {
        this.asyncInfoRequestCollection = this.asyncInfoRequestCollection.filter(s => s.Id != request.Id);

        this.visible = this.getRequestCount() > 0;
    }

    getRequestCount() {
        return this.asyncInfoRequestCollection.length;
    }

    showDialog() {
        this.asyncPopup.showDialog(this.asyncInfoRequestCollection);
    }
}
